import { useEffect, useRef } from 'react';
var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
/**
 * Detect click and touch events outside of specified element
 * Documentation: https://mantine.dev/hooks/use-click-outside/
 */
export function useClickOutside(handler, events, nodes) {
    var ref = useRef();
    useEffect(function () {
        var listener = function (event) {
            if (Array.isArray(nodes)) {
                var shouldTrigger = nodes.every(function (node) { return !!node && !node.contains(event.target); });
                if (!shouldTrigger) {
                    handler();
                }
            }
            else if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        (events || DEFAULT_EVENTS).forEach(function (fn) { return document.addEventListener(fn, listener); });
        return function () {
            ;
            (events || DEFAULT_EVENTS).forEach(function (fn) { return document.removeEventListener(fn, listener); });
        };
    }, [ref, handler, nodes]);
    return ref;
}
